import React, { useEffect, useState } from "react";
import { Button, Col } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { Field, formValueSelector, reduxForm } from "redux-form";
import InputPhoneNumberLogin from "../../components/input/renderFieldPhoneLogin";
import { handleApiErrors } from "../../lib/api-errors";

import { replaceAll } from "../../util";
import {
  lengthRequired,
  required,
  validateEmail,
  validatePhone,
} from "../../util/validation";
import { setDataAccount } from "../client/actions";

import CASCLogo from "../../assets/img/casc_logo.png";
import CASCPhone from "../../assets/img/phone-ctck.png";
import RenderFieldInputLogin from "../../components/input/renderInputLogin";

import { Autoplay, Mousewheel, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";

import Banner1 from "../../assets/img/asset/banner_1.png";
// import Banner2 from "../../assets/img/asset/banner_2.png";

const length10 = lengthRequired(10);

const apiUrl = `${process.env.REACT_APP_API_URL}`;

function PageCheckAccount(props) {
  const history = useHistory();
  const dispatch = useDispatch();

  const { handleSubmit } = props;

  const [loading, setLoading] = useState(false);
  const [hasAccount, setHasAccount] = useState(false);

  useEffect(() => {
    setLoading(false);
    setHasAccount(false);
  }, []);

  function submit(values) {
    const { inputName, inputPhone, inputMail } = values;

    setLoading(true);

    const param = {
      user: "back",
      cmd: "CHECK_OPENACC",
      param: {
        C_MOBILE: replaceAll(inputPhone, " ", ""),
        C_EMAIL: inputMail,
      },
    };

    const _data = {
      C_NAME: inputName,
      C_MOBILE: replaceAll(inputPhone, " ", ""),
      C_EMAIL: inputMail,
    };

    dispatch(setDataAccount(_data));

    checkAccountRequestApi(param);
  }

  function checkAccountRequestApi(data) {
    const url = `${apiUrl}/verifyPhoneEmail`;
    const request = fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify(data),
    });

    request
      .then(handleApiErrors)
      .then((response) => response.json())
      .then((json) => {
        if (json.iRs > 0) {
          // chưa có tài khoản
          history.push("/open-account/verify-otp");
        } else {
          // đã có tài khoản
          setHasAccount(true);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        throw error;
      });
  }

  return (
    <div className="form-check-account d-flex">
      <Col className="p-0 m-0">
        <div className="head-desk-swiper">
          <Swiper
            cssMode={true}
            navigation={false}
            pagination={true}
            mousewheel={true}
            keyboard={true}
            autoplay={{ delay: 5000 }}
            loop={false}
            modules={[Autoplay, Pagination, Mousewheel]}
          >
            <SwiperSlide>
              <img src={Banner1} alt="" />
            </SwiperSlide>
            {/**<SwiperSlide>
              <img src={Banner2} alt="" />
            </SwiperSlide>  */}
          </Swiper>
          <div className="panel-login">
            <a href="tel:1900633059">
              <img src={CASCPhone} alt="" />
            </a>
            <div className="form-login py-5 mt-3">
              <div>
                <img
                  src={CASCLogo}
                  style={{ height: "45px" }}
                  alt="casc_logo"
                />
              </div>
              <div className="text-main mt-3">
                <span>Đăng ký mở tài khoản</span>
              </div>
              <form
                className="d-flex flex-column align-items-center w-100 mt-3"
                onSubmit={handleSubmit(submit)}
              >
                <div className="form-group w-100 px-4">
                  <label htmlFor="inputName" className="pl-3">
                    Họ và tên <span className="text-danger">*</span>
                  </label>
                  <Field
                    name="inputName"
                    type="text"
                    className="form-control input-type-1"
                    placeholder="Nhập họ và tên"
                    component={RenderFieldInputLogin}
                    validate={required}
                  />
                </div>
                <div className="form-group w-100 px-4">
                  <label htmlFor="inputPhone" className="pl-3">
                    Số điện thoại <span className="text-danger">*</span>
                  </label>
                  <Field
                    name="inputPhone"
                    type="text"
                    className="form-control input-type-1"
                    placeholder="Nhập số điện thoại"
                    component={InputPhoneNumberLogin}
                    validate={[required, length10, validatePhone]}
                  />
                </div>
                <div className="form-group w-100 px-4">
                  <label htmlFor="inputMail" className="pl-3">
                    Email <span className="text-danger">*</span>
                  </label>
                  <Field
                    name="inputMail"
                    type="text"
                    className="form-control input-type-1"
                    placeholder="Nhập Email"
                    component={RenderFieldInputLogin}
                    validate={[required, validateEmail]}
                  />
                </div>
                <Button
                  className="my-3 btn-submit"
                  type="submit"
                  disabled={loading}
                >
                  TIẾP TỤC MỞ TÀI KHOẢN
                </Button>
              </form>
              {hasAccount && (
                <p className="text-danger mb-1">
                  Quý khách đã có tài khoản tại CASC.{" "}
                  <a
                    href="https://trading.casc.vn/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Đăng nhập
                  </a>
                </p>
              )}
              {!hasAccount && (
                <p className="mb-1 fz-14">
                  Bạn đã có tài khoản?{" "}
                  <a
                    href="https://trading.casc.vn/"
                    className="font-weight-bold"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Đăng nhập
                  </a>
                </p>
              )}
            </div>
          </div>
        </div>
      </Col>
    </div>
  );
}

PageCheckAccount = reduxForm({
  form: "accountstep1",
  enableReinitialize: true,
})(PageCheckAccount);

const selector = formValueSelector("accountstep1");

const mapStateToProps = (state) => {
  const { inputName, inputPhone, inputMail } = selector(
    state,
    "idSale",
    "inputPhone",
    "inputMail"
  );

  return {
    inputName,
    inputPhone,
    inputMail,
    initialValues: {
      inputName: "",
      inputPhone: "",
      inputMail: "",
    },
  };
};

export default connect(mapStateToProps)(PageCheckAccount);
